import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

/**
 * ＤＮＡ情報リストを取得する
 *
 * @export API通信成功時の処理
 * @class DnaInfoComboBoxService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class DnaInfoComboBoxService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private model: any; // DnaInfoComboBoxModel・DnaInfoCheckBoxListModelが入る
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /** APIを呼ぶ */
  execute(model: any, successFunc: Function): void {
    this.model = model;
    this.successFunc = successFunc;
    this.send('KYMW02getDnaInfoList', null);
  }

  /** API通信成功時の処理(PlessResponderのメソッドをオーバーライド) */
  success(data: any) {
    if (this.successFunc !== null) {
      this.successFunc();
    }
    if (data !== null) {
      this.model.updateCodeList(data);
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof DnaInfoComboBoxService
   */
  exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }

}
